<template>
  <div class="badge">
    <span class="u-color-gray">公開</span>
  </div>
</template>

<script>
export default {
  name: "PublishBadge"
}
</script>

<style scoped lang="scss">
.badge {
  display: inline;
  padding: 3px 6px;
  border: 1px solid #CAC9C9;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
